import { Grid, Segmented } from "antd";
import React, { useState } from "react";
import QurealSection from "../common/QurealSection";
import SectionHeader from "../components/commons/SectionHeader";
import BrandPersonal from "./brands/person/BrandPersonal";
import BrandOrganization from "./brands/org/BrandOrganization";
import { TeamOutlined } from "@ant-design/icons";

const { useBreakpoint } = Grid;

function ManageBrands() {
    const [type, setType] = useState("organization");
    const screens = useBreakpoint();
    const isMobile = !screens.sm;

    return (
        <QurealSection
            header={
                <SectionHeader
                    heading="Manage Brands"
                    icon={<TeamOutlined />}
                />
            }
        >
            <div style={{ padding: isMobile ? "16px" : "15px" }}>
                <Segmented
                    options={[
                        {
                            label: "Organization",
                            value: "organization",
                            icon: null,
                        },
                        { label: "Person", value: "personal", icon: null },
                    ]}
                    value={type}
                    onChange={(value) => setType(value)}
                />
                {type === "personal" && <BrandPersonal />}
                {type === "organization" && <BrandOrganization />}
            </div>
        </QurealSection>
    );
}

export default ManageBrands;

// Some creations will be only organizations
// Some will be only personal
// Some will be both like visiting card which contains both info ie company and perosonal.
